<template>
  <v-textarea
      solo
      flat
      no-resize
      full-width
      :auto-grow="autogrow"
      :height="height"
      :readonly="readonly"
      :placeholder="readonly ? '' : placeholder"
      :disabled="disabled"
      color="var(--theme-color-one)"
      :class="[ 'custom-textfield-theme-' + theme ]"
      :hide-details="hideDetails"
      :append-inner-icon="appendInnerIcon"
      :value="value"
      @change="eventChange"
      @input="eventChange"
  ></v-textarea>
</template>

<script>
export default {
  name: "TextArea",
  props: {
    placeholder: {
      default: 'โปรดระบุ'
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    autogrow: {
      type: Boolean,
      default: false
    },
    height: {
      default: '82'
    },
    appendInnerIcon: {
      default: undefined
    },
    theme: {
      default: '1'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      default: ''
    }
  },
  methods: {
    eventChange (val) {
      this.$emit('onChange', val)
    }
  }
}
</script>

<style scoped lang="scss">

</style>